import {
  GET_ASSIGN_DRIVER_REQUESTED,
  GET_CANCEL_TRIP_REQUESTED,
  GET_INVOICE_DOWNLOAD_REQUESTED,
  GET_INVOICE_REQUESTED,
  GET_SOS_ALERT_REQUESTED,
  GET_TRIP_REQUESTED,
  GET_RESERVATIONDETAILS,
} from "resources/actionTypes";

export function getTrip(data) {
  return {
    type: GET_TRIP_REQUESTED,
    payload: data,
  };
}
export function getSosAlert(data) {
  return {
    type: GET_SOS_ALERT_REQUESTED,
    payload: data,
  };
}
export function postCancelTrip(data) {
  return {
    type: GET_CANCEL_TRIP_REQUESTED,
    payload: data,
  };
}
export function getAssignDriver(data) {
  return {
    type: GET_ASSIGN_DRIVER_REQUESTED,
    payload: data,
  };
}
export function getInvoice(data) {
  return {
    type: GET_INVOICE_REQUESTED,
    payload: data,
  };
}
export function getInvoiceDownload(data) {
  return {
    type: GET_INVOICE_DOWNLOAD_REQUESTED,
    payload: data,
  };
}

export function getReservationDetails(reservationPayload) {
  return {
    type: GET_RESERVATIONDETAILS.GET_RESERVATIONDETAILS_REQUESTED,
    payload: reservationPayload,
  };
}
export function getAvailableVehicles(payload) {
  return {
    type: "GET_AVAILABLE_VEHICLES_REQUESTED",
    payload: payload,
  };
}
export function assignSubvendorResponse(payload) {
  return { type: "ASSIGN_SUBVENDOR_RESPONSE_REQUESTED", payload };
}

export function getDriverAssigns(payload) {
  return { type: "GET_DRIVER_ASSIGNS_REQUESTED", payload };
}

export function assignDriverToTrip(payload) {
  return { type: "ASSIGN_DRIVER_TO_TRIP_REQUESTED", payload };
}
